module.exports = __webpack_public_path__ + "img/dateEle.45bf0c09.svg";